/**
 * Identifiers for tabs in the plan details dialog.
 */ export var PlanDetailsTab = /*#__PURE__*/ function(PlanDetailsTab) {
    PlanDetailsTab["ProjectDetails"] = "ProjectDetails";
    PlanDetailsTab["Scheduling"] = "Scheduling";
    PlanDetailsTab["Appearance"] = "Appearance";
    PlanDetailsTab["SharingAndSecurity"] = "SharingAndSecurity";
    return PlanDetailsTab;
}({});
